import React from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import routes from '../../../config/routes'
import history from '../../../lib/history'
import { formatCNPJ } from '../../../lib/format'
import BoxRounded from '../../commons/BoxRounded/BoxRounded'
import Breadcrumb from '../../commons/Breadcrumb/Breadcrumb'
import DefaultLayout from '../../commons/Layouts/DefaultLayout'
import Text from '../../commons/Text/Text'
import Collapse from '../../commons/Collapse/Collapse'
import DetailStoreInfo from './DetailStoreInfo'
import DetailStoreAddress from './DetailStoreAddress'
import DetailStoreContact from './DetailStoreContact'
import styles from './detailStore.module.scss'

const DetailStore = (props) => {
  const {
    match: {
      params: { id }
    }
  } = props

  const {
    extract: { store }
  } = useSelector((state) => state.extractReducer)

  if (!store?.walletCode) {
    history.push(routes.extract.generate(id))

    return null
  }

  const breadcrumbs = [
    {
      id: 1,
      title: 'Carteira',
      path: routes.wallet.path
    },
    {
      id: 2,
      title: store?.nameFantasy,
      path: routes.extract.generate(id)
    },
    {
      id: 3,
      title: 'Dados da loja'
    }
  ]

  return (
    <DefaultLayout>
      <Text color="gray" size="lg" variation="dark" bold>
        {store?.nameFantasy}
      </Text>
      <Breadcrumb items={breadcrumbs} />
      <div style={{ display: 'flex', gap: 37, flexWrap: 'wrap' }}>
        <div className={styles.leftColumn}>
          <DetailStoreInfo {...{ ...store }} />
          <DetailStoreAddress {...{ ...store }} />
          <DetailStoreContact {...{ ...store }} />
        </div>

        <div style={{ flexGrow: 1 }}>
          <BoxRounded>
            {store.nameFactory && (
              <Collapse opened title="Razão social">
                <Text color="gray" variation="dark" size="xxs">
                  {store.nameFactory}
                </Text>
              </Collapse>
            )}

            {store.cnpj && (
              <Collapse opened title="CNPJ">
                <Text color="gray" variation="dark" size="xxs">
                  {formatCNPJ(store.cnpj)}
                </Text>
              </Collapse>
            )}

            {store.subsidiary && (
              <Collapse opened title="Regional">
                <Text color="gray" variation="dark" size="xxs">
                  {store.subsidiary}
                </Text>
              </Collapse>
            )}

            <Collapse opened title="Contatos da loja">
              {store?.nameOwner && (
                <>
                  <Text
                    size="xs"
                    color="gray"
                    variation="dark"
                    bold
                    margin="18px 0 11px"
                  >
                    Proprietário da Loja
                  </Text>
                  <Text color="gray" variation="dark" font="custom" size="xxs">
                    {store?.nameOwner}
                  </Text>
                </>
              )}
              {store?.nameFinancialDirector && (
                <>
                  <div className={styles.divider} />
                  <Text
                    size="xs"
                    color="gray"
                    variation="dark"
                    bold
                    margin="18px 0 11px"
                  >
                    Diretor financeiro
                  </Text>
                  <Text color="gray" variation="dark" font="custom" size="xxs">
                    {store?.nameFinancialDirector}
                  </Text>
                </>
              )}
              {store?.nameCommercialDirector && (
                <>
                  <div className={styles.divider} />
                  <Text
                    size="xs"
                    color="gray"
                    variation="dark"
                    bold
                    margin="18px 0 11px"
                  >
                    Diretor comercial
                  </Text>
                  <Text color="gray" variation="dark" font="custom" size="xxs">
                    {store?.nameCommercialDirector}
                  </Text>
                </>
              )}
              {store?.nameSalesman && (
                <>
                  <div className={styles.divider} />
                  <Text
                    size="xs"
                    color="gray"
                    variation="dark"
                    bold
                    margin="18px 0 11px"
                  >
                    Vendedor(a)
                  </Text>
                  <Text color="gray" variation="dark" font="custom" size="xxs">
                    {store?.nameSalesman}
                  </Text>
                </>
              )}
              {store?.phoneNumberSalesmanDdd && store?.phoneNumberSalesman && (
                <>
                  <div className={styles.divider} />
                  <Text
                    size="xs"
                    color="gray"
                    variation="dark"
                    bold
                    margin="18px 0 11px"
                  >
                    Telefone do(a) vendedor(a)
                  </Text>
                  {store?.phoneNumberSalesmanDdd && (
                    <Text
                      color="gray"
                      variation="dark"
                      font="custom"
                      size="xxs"
                    >
                      ({store?.phoneNumberSalesmanDdd})
                      {store?.phoneNumberSalesman}
                    </Text>
                  )}
                </>
              )}
            </Collapse>
            {store.hasGroup && (
              <Collapse opened title="Grupo">
                {store?.groupCode && (
                  <>
                    <div className={styles.divider} />
                    <Text
                      size="xs"
                      color="gray"
                      variation="dark"
                      bold
                      margin="18px 0 11px"
                    >
                      Cód. grupo
                    </Text>
                    <Text
                      color="gray"
                      variation="dark"
                      font="custom"
                      size="xxs"
                    >
                      {store?.groupCode}
                    </Text>
                  </>
                )}
                {store?.groupName && (
                  <>
                    <div className={styles.divider} />
                    <Text
                      size="xs"
                      color="gray"
                      variation="dark"
                      bold
                      margin="18px 0 11px"
                    >
                      Nome do grupo
                    </Text>
                    <Text
                      color="gray"
                      variation="dark"
                      font="custom"
                      size="xxs"
                    >
                      {store?.groupName}
                    </Text>
                  </>
                )}
                {store?.groupCnpjMatriz && (
                  <>
                    <div className={styles.divider} />
                    <Text
                      size="xs"
                      color="gray"
                      variation="dark"
                      bold
                      margin="18px 0 11px"
                    >
                      CNPJ Matriz
                    </Text>
                    <Text
                      color="gray"
                      variation="dark"
                      font="custom"
                      size="xxs"
                    >
                      {store?.groupCnpjMatriz}
                    </Text>
                  </>
                )}

                <div className={styles.divider} />
                <Text
                  size="xs"
                  color="gray"
                  variation="dark"
                  bold
                  margin="18px 0 11px"
                >
                  Possui mais de uma bandeira
                </Text>
                <Text color="gray" variation="dark" font="custom" size="xxs">
                  {store?.hasManyFlags ? 'Sim' : 'Não'}
                </Text>
                {store?.hasManyFlags && (
                  <>
                    <Text
                      size="xs"
                      color="gray"
                      variation="dark"
                      bold
                      margin="18px 0 11px"
                    >
                      Possui mais de uma bandeira
                    </Text>
                    <Text
                      color="gray"
                      variation="dark"
                      font="custom"
                      size="xxs"
                    >
                      {store?.flag}
                    </Text>
                  </>
                )}
              </Collapse>
            )}

            {store?.hasShopping && (
              <Collapse opened title="Shopping">
                {store?.shoppingCnpj && (
                  <>
                    <Text
                      size="xs"
                      color="gray"
                      variation="dark"
                      bold
                      margin="18px 0 11px"
                    >
                      CNPJ shopping
                    </Text>
                    <Text
                      color="gray"
                      variation="dark"
                      font="custom"
                      size="xxs"
                    >
                      {store?.shoppingCnpj}
                    </Text>
                  </>
                )}

                {store?.shoppingWebsite && (
                  <>
                    <div className={styles.divider} />
                    <Text
                      size="xs"
                      color="gray"
                      variation="dark"
                      bold
                      margin="18px 0 11px"
                    >
                      Site shopping
                    </Text>
                    <Text
                      color="gray"
                      variation="dark"
                      font="custom"
                      size="xxs"
                    >
                      {store?.shoppingWebsite}
                    </Text>
                  </>
                )}
              </Collapse>
            )}

            {(store?.agentCertifiedName ||
              store?.agentCertifiedExpiredAt ||
              store?.norkonExpiredAt) && (
              <Collapse opened title="Status de sistemas regulatórios">
                {store?.agentCertifiedName && (
                  <>
                    <Text
                      size="xs"
                      color="gray"
                      variation="dark"
                      bold
                      margin="18px 0 11px"
                    >
                      Agente certificado
                    </Text>
                    <Text
                      color="gray"
                      variation="dark"
                      font="custom"
                      size="xxs"
                    >
                      {store?.agentCertifiedName}
                    </Text>
                  </>
                )}
                {store?.agentCertifiedExpiredAt && (
                  <>
                    <div className={styles.divider} />
                    <Text
                      size="xs"
                      color="gray"
                      variation="dark"
                      bold
                      margin="18px 0 11px"
                    >
                      Data de validade certificado
                    </Text>
                    <Text
                      color="gray"
                      variation="dark"
                      font="custom"
                      size="xxs"
                    >
                      {store?.agentCertifiedExpiredAt}
                    </Text>
                  </>
                )}
                {store?.norkonExpiredAt && (
                  <>
                    <div className={styles.divider} />
                    <Text
                      size="xs"
                      color="gray"
                      variation="dark"
                      bold
                      margin="18px 0 11px"
                    >
                      Data de vencimento Norkon
                    </Text>
                    <Text
                      color="gray"
                      variation="dark"
                      font="custom"
                      size="xxs"
                    >
                      {store?.norkonExpiredAt}
                    </Text>
                  </>
                )}
              </Collapse>
            )}
          </BoxRounded>
        </div>
      </div>
    </DefaultLayout>
  )
}

DetailStore.defaultProps = {
  match: {
    params: {
      id: null
    }
  }
}

DetailStore.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string
    })
  })
}

export default DetailStore
